<template>
  <vca-column>
    <vca-dropdown
      :taggable="true"
      :multiple="false"
      v-model="artists"
      :options="artistList"
      label=""
      :placeholder="$t('events.artist.placeholder')"
    ></vca-dropdown>
  </vca-column>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TakingArtistDropdown",
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      artistList: "artists/artistList",
    }),
    artists: {
      get() {
        return [];
      },
      set(value) {
        const selectedName = value.length > 0 ? value[0].label : "";
        this.$emit("input", selectedName);
      },
    },
  },
};
</script>
